import type { CategoryIconKind } from './categoryIconRules'
import { categoryIconUrl } from './categoryIconAssets'

export interface CategoryIconTileProps {
  /** Конкретная иконка (не выводится из названия). */
  kind: CategoryIconKind
  /** Оставлено для совместимости: цвет уже зашит в SVG. */
  colorKey?: number
  size?: number
  /** Оставлено для совместимости: скругление уже зашито в SVG. */
  rounded?: number
  className?: string
}

/**
 * Плитка иконки для галереи в админке: тот же SVG-файл, что и на кассе.
 * Вид задаётся явно, а не по названию категории.
 */
export function CategoryIconTile({
  kind,
  size = 96,
  className
}: CategoryIconTileProps) {
  const url = categoryIconUrl(kind)
  if (!url) return null
  return (
    <img
      src={url}
      alt=""
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  )
}
